import { render, staticRenderFns } from "./view-media.vue?vue&type=template&id=bb9fe968"
import script from "./view-media.vue?vue&type=script&lang=js"
export * from "./view-media.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports